import React from "react";

const DashboardIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66667 2H3C2.44772 2 2 2.44771 2 3V5.66667C2 6.21895 2.44771 6.66667 3 6.66667H5.66667C6.21895 6.66667 6.66667 6.21895 6.66667 5.66667V3C6.66667 2.44772 6.21895 2 5.66667 2Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0007 2H10.334C9.7817 2 9.33398 2.44771 9.33398 3V5.66667C9.33398 6.21895 9.7817 6.66667 10.334 6.66667H13.0007C13.5529 6.66667 14.0007 6.21895 14.0007 5.66667V3C14.0007 2.44772 13.5529 2 13.0007 2Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0007 9.33301H10.334C9.7817 9.33301 9.33398 9.78072 9.33398 10.333V12.9997C9.33398 13.552 9.7817 13.9997 10.334 13.9997H13.0007C13.5529 13.9997 14.0007 13.552 14.0007 12.9997V10.333C14.0007 9.78072 13.5529 9.33301 13.0007 9.33301Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66667 9.33301H3C2.44772 9.33301 2 9.78072 2 10.333V12.9997C2 13.552 2.44771 13.9997 3 13.9997H5.66667C6.21895 13.9997 6.66667 13.552 6.66667 12.9997V10.333C6.66667 9.78072 6.21895 9.33301 5.66667 9.33301Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardIcon;
